module.exports = __webpack_public_path__ + "static/img/resolvent2.dcb76f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent2.png
// module id = oyWm
// module chunks = 13